
import { Card, CircularProgress, createTheme, IconButton, Tab, Tabs, withStyles } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import Select from 'react-select';
import { BLUE } from '../../../_config/consts';
import AreaIconCustom from '../../CustomIcons/AreaIconCustom.jsx';
import AreaRemoveIconCustom from '../../CustomIcons/AreaRemoveIconCustom.jsx';
import UsersIconCustom from '../../CustomIcons/UsersIconCustom.jsx';
import NewspaperIconCustom from '../../CustomIcons/NewspaperIconCustom.jsx';

const styles = theme => ({
  titleText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: 5,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '98.7%',
    borderRadius: 10,
    padding: 10,
    marginTop: 20,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'visible',
    margin: 5,
    marginRight: 0,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  icon: {
    fontSize: 40,
    color: '#3f3f3f',
  },
  progress: {
    margin: 0,
    marginTop: 0,
    padding: 0,
    left: '50%',
    position: 'absolute',
    height: '38px !important',
    width: '38px !important',
    zIndex: 10000,
  },
  refreshHeader: {
    position: 'absolute',
    right: 10,
    top: 5,
    display: 'flex',
    alignItems: 'center',
  },
  filterHeader: {
    position: 'absolute',
    left: 10,
    top: 70,
    minWidth: 500,
    maxWidth: 700,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  refreshIcon: {
    fontSize: 30,
  },
  chartContainer: {
    width: '100%',
    maxHeight: 400,
    overflowY: 'scroll',
    marginTop: 10,
  },
  tableColumnText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  tabsContainer: {
    width: '100%',
    marginTop: 80,
  },
  loadMoreButton: {
    marginTop: 10,
    marginBottom: 10,
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const EmptyTableView = () => (
  <div style={{ height: 100, flexDirection: 'column', margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 50 }}>
    <AreaRemoveIconCustom style={{ color: '#bdbdbd', width: 35 }} />
    <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', marginTop: 0, fontSize: 18 }}><Entity entity="noUsersActivityFound" /></h3>
  </div>
);

class AreasDetailsTable extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedAreas: [],
      selectedGuest: null,
      guestsOptions: [],
      activeTab: 0,
      isLoadingDetails: false,
    }
  }

  async componentWillMount() {
    const { initialArea } = this.props;
    if (initialArea && initialArea.id && initialArea.name)
      this.setState({ selectedAreas: [{value: initialArea.id, label: initialArea.name}] });
  }

  componentWillReceiveProps(nextProps) {
    const { initialArea: oldValue } = this.props;
    const { initialArea: newValue } = nextProps;
    const { selectedAreas } = this.state;
    if (_.isEmpty(selectedAreas) && oldValue != newValue && newValue && newValue.id && newValue.name) {
      this.setState({ selectedAreas: [{value: newValue.id, label: newValue.name}] });
    }
  }

  async onSelectAreas(areasSelected) {
    const { onSelectAreas, areas } = this.props;
    
    // areasSelected is an array of {value, label} objects from react-select
    const selectedAreasArray = areasSelected || [];
    this.setState({ selectedAreas: selectedAreasArray });
    
    // Get the full area objects that match the selected values
    const selectedAreaIds = _.map(selectedAreasArray, 'value');
    const areasSearch = areas && areas.length ? areas.filter(e => _.includes(selectedAreaIds, e.id)) : [];
    
    // Call the parent callback with the selected areas
    onSelectAreas(areasSearch);
    
    // If on details tab, trigger fetch with all selected area IDs
    const { activeTab } = this.state;
    if (activeTab === 1 && !_.isEmpty(selectedAreaIds)) {
      await this.fetchDetailsData(selectedAreaIds, 0);
    }
  }

  async onFilterGuests(value) {
    const { onFetchGuests } = this.props;
    if (!onFetchGuests || !value || value.length < 2) {
      return;
    }
    
    try {
      const guests = await onFetchGuests(value);
      const guestsOptions = _.map(guests, guest => ({
        value: guest.id,
        label: `${guest.firstname} ${_.first(guest.lastname)}. ${guest.email ? ` - ${guest.email}` : ''}`,
      }));
      this.setState({ guestsOptions });
    } catch (error) {
      console.error('Error fetching guests:', error);
    }
  }

  onSelectGuest(selectedGuests) {
    const { onSelectGuest } = this.props;
    this.setState({ selectedGuest: selectedGuests });
    
    if (onSelectGuest) {
      const guestIds = _.map(selectedGuests, 'value');
      onSelectGuest(guestIds);
    }
  }

  async onTabChange(event, newValue) {
    this.setState({ activeTab: newValue });
    
    // If switching to details tab and no data loaded yet, fetch it
    if (newValue === 1) {
      const { selectedAreas } = this.state;
      const { reportDetails } = this.props;
      const selectedAreaIds = _.map(selectedAreas, 'value');
      if (!_.isEmpty(selectedAreaIds) && _.isEmpty(reportDetails.content)) {
        await this.fetchDetailsData(selectedAreaIds, 0);
      }
    }
  }

  async fetchDetailsData(areaIds, page = 0) {
    const { onFetchAreaReportDetails } = this.props;
    if (!onFetchAreaReportDetails) return;

    try {
      this.setState({ isLoadingDetails: true });
      await onFetchAreaReportDetails(areaIds, page);
      this.setState({ isLoadingDetails: false });
    } catch (error) {
      console.error('Error fetching details:', error);
      this.setState({ isLoadingDetails: false });
    }
  }

  async onLoadMore() {
    const { selectedAreas } = this.state;
    const { reportDetails } = this.props;
    const selectedAreaIds = _.map(selectedAreas, 'value');
    if (!_.isEmpty(selectedAreaIds) && reportDetails.pagination) {
      const currentPage = reportDetails.pagination.number || 0;
      await this.fetchDetailsData(selectedAreaIds, currentPage + 1);
    }
  }

  render() {
    const { areas, lastUpdate, textColor, fullWidth, isRefreshing, classes, onRefreshMetric, reportData, reportDetails } = this.props;
    const { selectedAreas, selectedGuest, guestsOptions, activeTab, isLoadingDetails } = this.state;
    
    // Get details data from props (passed from Redux)
    const detailsData = reportDetails ? reportDetails.content || [] : [];
    const pagination = reportDetails ? reportDetails.pagination || {} : {};
    const hasMoreData = pagination.last === false || false;
    
    return (
      <MuiThemeProvider theme={theme}>
        <Card className={classes.container} style={{ opacity: isRefreshing ? 0.5 : 1, marginRight: fullWidth ? 0 : 20 }} elevation={3}>
          <div className={classes.header}>
            <h3 className={classes.titleText} style={{ color: textColor || '#3f3f3f' }}><Entity entity="areaUsersActivity" /></h3>
            <div className={classes.headerTextIconContainer}>
              <AreaIconCustom style={{ width: 35, marginLeft: 10, color: textColor || '#3f3f3f' }} />
            </div>
          </div>
          <div className={classes.filterHeader} style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
            <Select
              value={selectedAreas}
              multi
              placeholder={<Entity entity="selectArea" />}
              noResultsText={<Entity entity="noResultsFound" />}
              onChange={val => this.onSelectAreas(val)}
              options={_.map(areas, area => ({ value: area.id, label: area.name }))}
              isClearable={true}
              style={{ minWidth: 250 }}
              styles={{
                container: (provided) => ({
                  ...provided,
                  minWidth: 200,
                  flex: 1,
                }),
                control: (provided) => ({
                  ...provided,
                  width: '100%',
                }),
              }}
            />
            <Select
              value={selectedGuest}
              placeholder={<Entity entity="findGuestToAdd" />}
              noResultsText={<Entity entity="noResultsFound" />}
              onChange={val => this.onSelectGuest(val)}
              onInputChange={value => this.onFilterGuests(value)}
              options={guestsOptions}
              isClearable={true}
              multi
              style={{ minWidth: 300}}
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: 200,
                  flex: 1,
                }),
                control: (provided) => ({
                  ...provided,
                  width: 500,
                }),
              }}
            />
          </div>
          {!reportData || _.isEmpty(reportData) ? null : (
          <div className={classes.tabsContainer}>
            <Tabs
              value={activeTab}
              onChange={(e, val) => this.onTabChange(e, val)}
              indicatorColor="primary"
              textColor="primary"
              scrollable
              style={{ alignSelf: 'flex-start' }}
              TabIndicatorProps={{
                style: { display: 'none' }
              }}
              >
                <Tab icon={<UsersIconCustom style={{ width: 26 }} />}  label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="summary" /></h5>} />
                <Tab icon={<NewspaperIconCustom style={{ width: 26 }} />}  label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="details" /></h5>} />
              </Tabs>
            </div>
          )}
          {/* Summary Tab */}
          {activeTab === 0 && (
            <div className={classes.chartContainer}>
              {!reportData || _.isEmpty(reportData) ? (
                <EmptyTableView />
              ) : (
                <Card className={classes.container} elevation={3}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="firstName" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="surname" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="email" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="area" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="entryCount" /></h5></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {_.map(reportData, (user, index) => (
                        <TableRow key={`${user.email}-${user.areaName}-${index}`} hover>
                          <TableCell>
                            <h5 style={{ color: '#3f3f3f' }}>{user.firstname || 'N/A'}</h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}>{user.lastname || 'N/A'}</h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}><strong>{user.email || 'N/A'}</strong></h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}><strong>{user.areaName || 'N/A'}</strong></h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ color: '#3f3f3f' }}><strong>{user.entryCount || 0}</strong></h5>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Card>
              )}
            </div>
          )}

          {/* Details Tab */}
          {activeTab === 1 && (
            <div className={classes.chartContainer}>
              {_.isEmpty(detailsData) && !isLoadingDetails ? (
                <EmptyTableView />
              ) : (
                <Card className={classes.container} elevation={3}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="firstName" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="surname" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="email" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="area" /></h5></TableCell>
                        <TableCell><h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}><Entity entity="areaUsersActivityTimestamp" /></h5></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {_.map(detailsData, (entry, index) => (
                        <TableRow key={`${entry.email}-${entry.areaName}-${index}`} hover>
                          <TableCell>
                            <h5 style={{ color: '#3f3f3f' }}>{entry.firstname || 'N/A'}</h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}>{entry.lastname || 'N/A'}</h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}><strong>{entry.email || 'N/A'}</strong></h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ margin: 0, color: '#3f3f3f' }}><strong>{entry.areaName || 'N/A'}</strong></h5>
                          </TableCell>
                          <TableCell>
                            <h5 style={{ color: '#3f3f3f' }}>{entry.timestamp ? moment(entry.timestamp).format('DD MMMM YYYY HH:mm:ss') : '---'}</h5>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {hasMoreData && !isLoadingDetails && (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                      <IconButton 
                        className={classes.loadMoreButton}
                        onClick={() => this.onLoadMore()}
                        color="primary"
                      >
                        <h5 style={{ margin: 0, color: BLUE }}><Entity entity="loadMore" /></h5>
                      </IconButton>
                    </div>
                  )}
                  {isLoadingDetails && (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
                      <CircularProgress size={30} color="primary" />
                    </div>
                  )}
                </Card>
              )}
            </div>
          )}
          
          <div className={classes.refreshHeader}>
            <h5 style={{ color: '#3f3f3f', margin: 0, marginTop: 2 }}>{<Entity entity="lastUpdate" />}: {moment(lastUpdate).format('LLL')}</h5>
            <IconButton
              disabled={isRefreshing}
              style={{ opacity: isRefreshing ? 0.5 : 1 }}
              onClick={() => onRefreshMetric && onRefreshMetric('NOT_USED')}
            >
              <RefreshIcon className={classes.refreshIcon} style={{ color: textColor || BLUE }} />
            </IconButton>
          </div>
          {isRefreshing ? <CircularProgress color="primary" className={classes.progress} /> : null}
        </Card>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(AreasDetailsTable);
